import { FC, useState } from 'react';

import { router } from '@inertiajs/react';

import { OrderCancellationReasonFields } from './OrderCancellationReasonFields';
import { ConfirmCancelModalState } from './ConfirmCancelModal.types';
import { CONFIRM_CANCEL_MODAL_TEXT } from './ConfirmCancelModalText';
import { Button } from '../../../../components/ui/Button';
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '../../../../components/ui/Dialog';
import { profileOrderActionRoute } from '../../../../models/routes';
import { OrderCancellationReason } from '../../../../types';

interface Props {
    state: ConfirmCancelModalState;
    setState: (state: ConfirmCancelModalState) => void;
    reasons: OrderCancellationReason[];
}

export const ConfirmCancelModal: FC<Props> = ({ state, setState, reasons }) => {
    const [loading, setLoading] = useState(false);
    const [reasonId, setReasonId] = useState('');
    const [comment, setComment] = useState('');
    const selectedReason = reasons.find(
        (reason) => String(reason.id) === reasonId,
    );
    const modalText = CONFIRM_CANCEL_MODAL_TEXT[state.action];

    const submit = () => {
        if (!state.orderId || !reasonId) return;

        setLoading(true);

        router.patch(
            profileOrderActionRoute(state.orderId, state.action),
            {
                reason_id: reasonId,
                comment,
            },
            {
                onSuccess: () => {
                    setState({ ...state, open: false });
                    setReasonId('');
                    setComment('');
                },
                onError: () => setLoading(false),
                onFinish: () => setLoading(false),
            },
        );
    };

    return (
        <Dialog
            open={state.open}
            onOpenChange={(open) => {
                if (!loading) {
                    setState({ ...state, open });
                }
            }}
        >
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>{modalText.title}</DialogTitle>
                </DialogHeader>

                <OrderCancellationReasonFields
                    description={modalText.description}
                    reasons={reasons}
                    reasonId={reasonId}
                    comment={comment}
                    selectedReason={selectedReason}
                    disabled={loading}
                    onReasonChange={(value) => {
                        setReasonId(value);
                        setComment('');
                    }}
                    onCommentChange={setComment}
                />

                <DialogFooter className="flex-col gap-2 sm:flex-row sm:gap-0">
                    <Button
                        variant="outline"
                        onClick={() => setState({ ...state, open: false })}
                        className="mt-2 w-full sm:mt-0 sm:w-auto"
                        disabled={loading}
                    >
                        Відмінити
                    </Button>
                    <Button
                        onClick={submit}
                        className="w-full sm:w-auto"
                        disabled={
                            loading ||
                            !reasonId ||
                            (selectedReason?.comment_required &&
                                comment.trim().length === 0)
                        }
                    >
                        {modalText.submitLabel}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
